module.exports = __webpack_public_path__ + "static/media/upload_pink.d25229f5.svg";